module.exports = __webpack_public_path__ + "cc293d4ef3ed6cef641a0e8059569335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/inactive-icon-hair@2x.png
// module id = 1761
// module chunks = 0